import { render } from "./HairdressersPage.vue?vue&type=template&id=43ac1178"
import script from "./HairdressersPage.vue?vue&type=script&lang=js"
export * from "./HairdressersPage.vue?vue&type=script&lang=js"

import "./HairdressersPage.vue?vue&type=style&index=0&id=43ac1178&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__